import { useContext, useMemo } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import useMemberEarlyAccessCheck from '../../helpers/useMemberEarlyAccessCheck';

export default function useActionButtonType(isQuickviewEdit = false) {
  const ProductPageState = useContext(ProductPageContext);
  const showMemberEarlyAccessButton = useMemberEarlyAccessCheck();

  const actionButtonType = useMemo(() => {
    if (!ProductPageState) return 'default';

    const { collectionData, featureFlags } = ProductPageState;
    const { isSelectedSkuSoldOut } = collectionData || {};
    const hasProductNotificationsEnabled = featureFlags?.['pdp-has-product-notifications-enabled'];

    if (showMemberEarlyAccessButton && !isQuickviewEdit) {
      return 'memberEarlyAccess';
    }

    if (collectionData?.activeProduct?.isAppExclusive && !isQuickviewEdit) {
      return 'appExclusive';
    }

    if (hasProductNotificationsEnabled && isSelectedSkuSoldOut) {
      return 'productNotifications';
    }

    return 'default';
  }, [ProductPageState, showMemberEarlyAccessButton, isQuickviewEdit]);

  return actionButtonType;
}
